import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useErrorDetails } from "redux/slice/commanSlice";
import DOMPurify from 'dompurify';

const InfoError = () => {
    const errorDetails = useErrorDetails();
    const sanitizedMessage = DOMPurify.sanitize(errorDetails["message"]);

    return (
        <div className="error-container h-100">
            <div className="error-wrapper h-100">
                <div className="error-content h-100">
                    <FontAwesomeIcon
                        className="error-icon"
                        color="#E7515A"
                        icon={faCircleExclamation}
                        size="2x"
                    />
                    <span className="error-title">
                        {errorDetails?.error || "Invalid User"}
                    </span>
                    <div
                        className="error-message"
                        dangerouslySetInnerHTML={{ __html: sanitizedMessage }}
                    ></div>
                </div>
            </div>
        </div>
    );
};

export default InfoError;
